import React, { useState } from "react";
import axios from "axios";

const Login = ({ setPatient }) => {
  const [patno, setPatno] = useState("");
  const [patphno, setPatphno] = useState("");
  const [error, setError] = useState("");

  const handleLogin = async () => {
    try {
      const response = await axios.post("https://ndcapps.in/webrptapi/klcheck/login.php", {
        patno,
        patphno,
      });

      if (response.data.success) {
        setPatient(response.data);
      } else {
        setError(response.data.message);
      }
    } catch (error) {
      setError("Server error. Please try again later.");
    }
  };

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-light">
      <div className="card shadow p-4" style={{ width: "22rem" }}>
        <h2 className="text-center mb-4">Patient Login</h2>
        
        <div className="mb-3">
          <label className="form-label">Patient No</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Patient No"
            value={patno}
            onChange={(e) => setPatno(e.target.value)}
          />
        </div>
        
        <div className="mb-3">
          <label className="form-label">Phone No</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Phone No"
            value={patphno}
            onChange={(e) => setPatphno(e.target.value)}
          />
        </div>

        {error && <p className="text-danger text-center">{error}</p>}

        <button className="btn btn-primary w-100" onClick={handleLogin}>
          Login
        </button>
      </div>
    </div>
    
  );
};

export default Login;
